import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";

const ModalConfirmacao = ({ isOpen, toggle, onConfirm, loading, title, message }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="sm">
      <ModalHeader toggle={toggle}>
        <span className="fw-semibold">{title}</span>
      </ModalHeader>
      <ModalBody>
        <p className="mb-0">{message}</p>
      </ModalBody>
      <ModalFooter>
        <Button type="button" color="light" onClick={toggle} disabled={loading}>
          Cancelar
        </Button>
        <Button type="button" color="danger" className="ms-2" onClick={onConfirm} disabled={loading}>
          {loading && <Spinner size="sm" className="me-2" />}
          Confirmar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalConfirmacao; 